"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PersonKontakt = function () {
  function PersonKontakt() {}
  PersonKontakt.EMAIL = 'email';
  PersonKontakt.FAX = 'fax';
  PersonKontakt.MOBIL = 'mobil';
  PersonKontakt.FEST = 'fest';
  return PersonKontakt;
}();
exports.PersonKontakt = PersonKontakt;